import { Record, Map as IMap, OrderedMap } from "immutable";

const InitialState = new Record({
  started: false,
  currentClientId: null,
  savedClients: new IMap(),
  // oktell
  oktellSync: false,
  oktellSyncStateChanges: false,
  oktellSyncError: null,
  calls: new OrderedMap(),
  currentCall: null,
  mostRecentCall: null,
  showCallInfo: false,
  // errors

  // servicedesk
  sdRequestLoading: false,
  sdRequestCompleted: false,
  sdRequestError: null,
});

export default InitialState;



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/reducer/InitialState.js